import find from 'lodash/find';
import React, { FC, useCallback } from 'react';
import styled from 'styled-components';

import { ActionType, RoutingPriority, SetPriorityAction as SetPriorityActionType } from 'src/actions/rules/actions';
import { StyledDropdown } from 'src/presentation/components/pages/rules/shared/StyledComponents';

type SetPriorityActionProps = {
  action: SetPriorityActionType;
  onUpdate: Function;
};

const SetPriorityAction: FC<SetPriorityActionProps> = ({ action, onUpdate }) => {
  const onChangePriority = useCallback(
    priority => {
      action.updatePriority(priority);
      onUpdate(ActionType.SetPriority, action);
    },
    [action, onUpdate]
  );

  return (
    <>
      <StyledDescription data-aid="setPriority-description">
        Customers who meet the set criteria will receive a boost in the inbox.
      </StyledDescription>
      <StyledDropdown
        data-aid="setPriority-selectButton"
        onSelect={onChangePriority}
        options={priorityOptions}
        placeholder="Select boost"
        value={action.priority}
      />
    </>
  );
};

const priorityOptions: { label: string; value: number }[] = [
  { label: 'Small', value: RoutingPriority.Low },
  { label: 'Medium', value: RoutingPriority.Medium },
  { label: 'Large', value: RoutingPriority.High },
  { label: 'Very Large', value: RoutingPriority.Extreme },
];

const StyledDescription = styled.div`
  padding-bottom: ${p => p.theme.spacing.large};
`;

export function getLabelForPriority(value: number): string {
  const priority = find(priorityOptions, { value });
  return priority ? priority.label : '';
}

export default SetPriorityAction;
